import './App.css';
import './components/elements/elements.css';
import './normalize.css';
import Login from "./components/login/Login";
import {useEffect, useState} from "react";
import MainMenu from "./components/MainMenu";
import Sidebar from "./components/navigation/sidebar";
import {useLocation} from "react-router-dom";
import Navbar from "./components/navigation/navbar";
import API from "./components/api/API.tsx";
import {loadFromStorage} from "./components/api/LocalStorage.tsx";
import {momentLocalizer} from "react-big-calendar";
import moment from "moment/moment";
import Calender from "./components/calender/Calender";
import Redirect from "./components/Redirect";

export const weexLocalizer = momentLocalizer(moment);

function App(){
  const [token, setToken] = useState(null);
  const path = useLocation().pathname;

  useEffect(() => {
    loadFromStorage("token").then(data => {
      setToken(data);
    });
  });
  return (
    <div className="App">
      <API setToken={setToken}>
        {
          path === "/calendar" ?
            <Calender isSchedulePlaner={null}/> :
            path === "/redirect" ?
              <Redirect/> :
              token == null ?
                <Login setToken={setToken}/> :
                <div>
                  <Navbar/>
                  {path !== "/" ?
                    <div className={"grid " + (path !== "/boxtv"? "gridtwo_App": "")}>
                      <Sidebar className={"sidebar"}/>
                      <MainMenu setToken={setToken}/>
                    </div> :
                    <MainMenu setToken={setToken}/>
                  }
                </div>
        }
      </API>
    </div>

  );
}

export default App;
